<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main expertise-detail" rel="main">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a>Home</a>
							</li>
							<li class="nav-link">
								<span>Expertise</span>
							</li>
							<li class="nav-link">
								<span>Energy, Mining &amp; Infrastructure</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<figure class="page-header  no-bg-img page-title-large headline-module__wrapper headline-module__headline"
				style="">
				<div class="page-wrapper">
					<div class="content">
						<h1 class="page-title">Energy, Mining &amp; Infrastructure</h1>
					</div>
				</div>
			</figure>
			<div class="page-wrapper headline-module__page-header ">
				<div class="embed-card">
					<div class="embed-card__embed embed-card__embed-bg">
						<img class="headline-module__image" src="../../assets/test/01.jpeg" alt="">
					</div>
					<div class="embed-card__content">
						<div class="embed-card__tag">
							Insight | Handbook
						</div>
						<h4 class="embed-card__title">
							Lithium FIRE: Global Foreign Investment Review Evaluation for Key Lithium Jurisdictions
						</h4>
						<div class="embed-card__copy">
							An overview and analysis of recent foreign investment review developments with a focus on
							lithium in a number of countries with substantial lithium reserves.
						</div>
						<a class="embed-card__link link--outbound">
							Read More
						</a>
					</div>
				</div>
			</div>
			<div class="orderable-modules">
				<div class="global-module-page-wrapper global-module">


					<div class="tabs-module global-module ">
						<div class="global-module-wrapper">


							<div class="tabs-panel-module js-tabs-panel-module">

								<div class="tabs-panel-nav js-tabs-panel-nav">
									<button class="tabs-panel-nav-toggle js-tabs-panel-nav-trigger">About</button>
									<ul class="tabs-panel-nav-list js-tabs-panel-nav-list">
										<li class="tabs-panel-nav-item">
											<button data-href="#about" aria-controls="about"
												class="tabs-panel-nav-link js-tabs-panel-nav-link " :class="tabIndex == 1 ? 'is-selected' : ''"
												role="button" @click="selectTab(1)">About</button>
										</li>
										<li class="tabs-panel-nav-item">
											<button data-href="#insight" aria-controls="insight"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 2 ? 'is-selected' : ''"
												role="button" @click="selectTab(2)">Insight</button>
										</li>
										<li class="tabs-panel-nav-item">
											<button data-href="#news" aria-controls="news"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 3 ? 'is-selected' : ''"
												role="button" @click="selectTab(3)">News</button>
										</li>
									</ul>
								</div>



								<div class="tabs-panels-all js-tabs-panel-all" style="">
									<a class="tab-anchor" id="about" target="_blank"></a>
									<div class="tabs-panel js-tabs-panel " :class="tabIndex == 1 ? 'is-active-panel' : ''">

										<div data-module-id="5e46827c-182f-49d4-b283-5f7f66ca4b5a" class="js-overview-expand">

											<div class="overview-intro description rte ">
												<p>The continuing need for energy and infrastructure assets to be
													replaced means investment is required on a global scale. Estimates
													by the International Energy Agency suggest there will be upwards of
													US$68 trillion invested in the world energy sector from 2015 to
													2040. With traditional public funding avenues now insufficient,
													creativity and innovation is required to help realize the next
													generation of projects.</p>
											</div>

											<div :style="{display:aboutSeeMore}" aria-hidden="true"
												data-overview-label-more="See More" data-overview-label-less="See Less"
												class="overview-full description js-overview-full rte">
												<p>These large-scale schemes require cross-border experience and the
													ability to devise tailored solutions to both domestic and
													international challenges. Working seamlessly across 47 countries, we
													can help clients to structure, acquire, finance and implement
													projects, and manage their investments, whether in developed,
													developing or transition countries.</p>
												<p>Building on our wealth of experience in this sector - we have been
													specializing in international energy, mining and infrastructure
													projects worldwide for more than 65 years – we understand the needs
													of both investors and financiers. Our transactional capability,
													coupled with our broad-ranging skills in finance, corporate, tax,
													and environmental and competition law, means we can deliver
													commercially effective solutions at every stage of the process.</p>
												<p>By combining an uncompromising commitment to excellence with our
													results-driven outlook, we can deliver high quality local law
													services in more jurisdictions across the globe than any other law
													firm. Thanks to our collaborative approach, we can provide the
													following energy and infrastructure-related legal services: </p>
												<ul>
													<li>Antitrust &amp; Competition – Our lawyers advise you from
														pre-transaction merger notices and filings with governmental
														authorities to all aspects of antitrust and competition
														litigation issues. </li>
													<li>Banking &amp; Finance – Our team can advise on all aspects
														related to new ways of project, acquisition, Islamic, structured
														and trade finance, as well as on issues related to financial
														regulation, funds and securitization. </li>
													<li>Dispute Resolution – Our energy industries team covers all
														aspects from strategic litigation analysis to litigation
														services, arbitration counsel and alternative dispute
														resolution. </li>
													<li>Employment – We can help you in regards to counseling on all
														aspects of employment law and multi-country employment projects,
														compensation and benefits, equity compensation, global
														migration, health &amp; safety, labor relations and trade
														union/works council issues. </li>
													<li>Environment and Environmental Markets – We have a long-standing
														commitment to helping companies respond to the risks and
														opportunities of environmental law and regulation anywhere
														around the globe. </li>
													<li>Global Financial Restructuring &amp; Insolvency – We analyze the
														strategic and legal alternatives to offer clear, appropriate
														solutions to urgent concerns. Our team will help you on all
														aspects of financial restructuring, insolvency, bankruptcy,
														litigation, and distressed M&amp;A issues related to energy and
														infrastructure. </li>
													<li>Intellectual Property – We can help you in all cases related to
														patent and trademark registration, portfolio management,
														prosecution and litigation. </li>
													<li>Mergers &amp; Acquisitions – Our lawyers understand your issues
														ranging from portfolio strategies, private and public M&amp;A,
														share and asset sales, joint ventures, privatizations, auctions
														and tender offers, leveraged buyouts, corporate reorganization
														and refinancing. </li>
													<li>Private Equity – We provide global advice from the establishment
														and structuring of new funds, to operations, acquisitions and
														dispositions, to the final exit planning and liquidation. </li>
													<li>Tax – Our team advises you on general tax planning arising from
														strategic planning, operations, and transactions; compliance;
														M&amp;A and corporate restructuring tax planning; business
														integration; divestitures; state and local tax issues; tax
														controversy and litigation; and transfer pricing strategies.
													</li>
												</ul>
											</div>
											<div class="overview-button-trigger">
												<button
													class="button-red button-medium button-expand js-overview-trigger"
													aria-expanded="false" aria-controls="readmoreText"
													@click="openAboutMore">See More</button>
											</div>
										</div>
									</div>
									<a class="tab-anchor" id="insight" target="_blank"></a>
									<div data-panel="" class="tabs-panel js-tabs-panel" :class="tabIndex == 2 ? 'is-active-panel' : ''">
										<div class="description intro">
											<p style="text-align: center;">Visit InsightPlus for our latest legal
												updates covering Energy, Mining &amp; Infrastructure developments across
												the globe</p>
											<p style="text-align: center;"><a><button class="button-red">Visit
														InsightPlus</button></a></p>
										</div>
										<div class="articles-related-module featured-insights js-articles-related-module">
											<div class="featured-insights__collection js-article-list"
												data-child-selector="4">
												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Legal
																		Update</div>
																	<div class="content-headline">Vietnam: February 2024
																		Draft circular on tariff determination and model
																		power purchase agreement (PPA) for IPP/private
																		investment power projects</div>
																	<div class="content-summary">The Ministry of
																		Industry and Trade of Vietnam (MOIT) recently
																		released a draft circular for public comments
																		("Draft Circular"), which if adopted would
																		replace Circular No. 57/2020 on tariff ...</div>
																</div>
															</div>
														</div>
													</a>
												</div>


												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Legal
																		Update</div>
																	<div class="content-headline">Malaysia: Update Large
																		Scale Solar Projects, Low Carbon Energy
																		Programme &amp; Net Energy Metering Programme
																	</div>
																	<div class="content-summary">In conjunction with
																		International Clean Energy Day, the Ministry of
																		Energy Transition and Public Utilities
																		("Ministry"), being the new Government ministry
																		in charge of the electricity ...</div>
																</div>
															</div>
														</div>
													</a>
												</div>


												<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="pcm-standard-background-image pcm-standard-background-image2">
															</div>
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Handbook
																	</div>
																	<div class="content-headline">Lithium FIRE</div>
																	<div class="content-summary">An overview and
																		analysis of recent foreign investment review
																		developments with a focus on lithium in a number
																		of countries with substantial lithium reserves.
																	</div>
																</div>
															</div>
														</div>
													</a>
												</div>

												<template v-if="moreInsight">
													<div class="featured-insights__tile promo-content-tile " >
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Legal
																			Update</div>
																		<div class="content-headline">Mergermarket: North
																			America Natural Resources
																			Trendspotter:<br>Gushing with Activity in 2023
																		</div>
																		<div class="content-summary">Thanks to several large
																			deals in oil and gas, deal activity in the
																			natural resources sector saw a 74%
																			year-over-year increase in deal volume in 2023.
																		</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[0] +') no-repeat',backgroundSize:'cover'}">
																</div>
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Thought
																			Leadership</div>
																		<div class="content-headline">The Year Ahead: Global
																			Disputes Forecast 2024 Report</div>
																		<div class="content-summary">Our seventh annual
																			report provides detailed analysis of disputes
																			trends to prepare your organization for 2024.
																		</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Legal
																			Update</div>
																		<div class="content-headline">Supporting clients to
																			seize Korea’s substantial opportunities</div>
																		<div class="content-summary">Our
																			lawyers&nbsp;discuss the abundant opportunities
																			that Korea presents and how the JV supports
																			clients with their Korea inbound and outbound
																			investments and business expansion.&nbsp;</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[1] +') no-repeat',backgroundSize:'cover'}">
																</div>
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Handbook
																		</div>
																		<div class="content-headline">Transition Finance:
																			New Opportunities and Challenges for Financial
																			Institutions</div>
																		<div class="content-summary">This sustainability
																			briefing on transition finance is relevant both
																			to lenders and borrowers in commercial and
																			syndicated lending. </div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[2] +') no-repeat',backgroundSize:'cover'}">
																</div>
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Podcast
																		</div>
																		<div class="content-headline">The Health Pod</div>
																		<div class="content-summary">The Health Pod, Baker
																			McKenzie's industry podcast series, highlights
																			sector-specific issues and trends that affect
																			healthcare and life sciences companies.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Handbook
																		</div>
																		<div class="content-headline">Nuclear Poland</div>
																		<div class="content-summary">A joint report focusing
																			on nuclear power development in Poland and the
																			challenges related to ongoing technological
																			transformation.&nbsp;
																		</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="promo-content-tile featured-insights__tile view-all-placeholder">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<span class="button-red">View All Insight</span>
																</div>
															</div>
														</a>
													</div>
												</template>
												
											</div>
											<button data-scroll-up="true" data-label-expand="See More Insight"
												data-label-collapse="See Less Insight"
												class="button-red button-expand js-button-expand" @click="showMoreInsight">See More
												Insight</button>
										</div>
									</div>
									<a class="tab-anchor" id="news" target="_blank"></a>
									<div data-panel="" class="tabs-panel js-tabs-panel" :class="tabIndex == 3 ? 'is-active-panel' : ''">
										<div class="articles-related-module featured-insights js-articles-related-module">
											<div class="featured-insights__collection js-article-list"
												data-child-selector="4">
												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Firm News
																	</div>
																	<div class="content-headline">2024 Legal 500 EMEA
																		Guide Highlights Growth in Baker McKenzie Lawyer
																		Rankings</div>
																	<div class="content-summary">The guide ranks Baker
																		McKenzie in 277 practice areas and its lawyers
																		in 292 categories.</div>
																</div>
															</div>
														</div>
													</a>
												</div>


												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Deal
																		Announcement</div>
																	<div class="content-headline">Baker McKenzie advises
																		Emeren Group on its agreement with Glennmont to
																		develop a pipeline of battery storage projects
																		in Italy</div>
																	<div class="content-summary">Baker McKenzie advised
																		Emeren Group on its agreement with Glennmont for
																		the acquisition and development of two battery
																		storage projects.</div>
																</div>
															</div>
														</div>
													</a>
												</div>


												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Case
																		Announcement</div>
																	<div class="content-headline">Baker McKenzie client
																		Iberdrola completes sale of part of its combined
																		cycle business in Mexico for USD 6.2 billion
																	</div>
																	<div class="content-summary">Divestment is
																		equivalent to 55% of Iberdrola’s gross operating
																		profit in the country.</div>
																</div>
															</div>
														</div>
													</a>
												</div>

												<template v-if="moreNews">
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			Gaw Capital on its partnership with BW ESS to
																			launch investment platform for battery projects
																		</div>
																		<div class="content-summary">The partnership comes
																			in light of the Australian government's rollout
																			of policy to support battery projects.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			the AEMC on new Rule Change to assist energy
																			sector participants to contribute to
																			Commonwealth, state and territory emissions
																			reduction targets</div>
																		<div class="content-summary">The Rule Change
																			potentially unlocks more transmission and
																			distribution projects able to achieve emissions
																			reductions.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			Nexif Ratch Energy on its acquisition of 30
																			megawatt Minh Luong hydropower plant in Vietnam
																		</div>
																		<div class="content-summary">This Minh Luong Project
																			has been in commercial operation since April
																			2018.&nbsp;</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			Global Ports Holding on its PPP Agreement and
																			financial closing for the San Juan Cruise Port
																		</div>
																		<div class="content-summary">Baker McKenzie has
																			advised Global Ports Holding Plc and the project
																			company San Juan Cruise Port LLC on the
																			successful closing of the Public-Private
																			Partnership Agreement for the San Juan Cruise
																			Port, ...</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													
													
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Insight</div>
																		<div class="content-headline">Baker McKenzie
																			launches Lithium FIRE report outlining global
																			foreign investment framework for key lithium
																			jurisdictions</div>
																		<div class="content-summary">Baker McKenzie has
																			launched its Lithium FIRE Report, outlining the
																			global foreign investment framework in key
																			lithium jurisdictions around the world. </div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="promo-content-tile featured-insights__tile view-all-placeholder">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<span class="button-red" @click="toPage('/newsroom')">View All News</span>
																</div>
															</div>
														</a>
													</div>
												</template>
												
											</div>
											<button data-scroll-up="true" data-label-expand="See More News"
												data-label-collapse="See Less News"
												class="button-red button-expand js-button-expand" @click="showMoreNews">See More News</button>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="global-module-page-wrapper-narrow">

					<div class="header-two-col-list global-practices global-module">
						<div class="global-module-wrapper">
							<div class="section-header-wrapper">
								<h2 class="section-header">How We Can Help</h2>
							</div>

							<ul class="secondary-links">
								<li class="column">
									<ul>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Environment
												&amp; Climate Change</a> </li>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Infrastructure</a>
										</li>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Mining &amp;
												Metals</a> </li>
									</ul>
								</li>
								<li class="column">
									<ul>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Oil, Gas
												&amp; Petrochemicals</a> </li>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Power</a> </li>
										<li class="secondary-link"> <a class="secondary-link-label related-practice">Renewable
												Energy &amp; Clean Technology</a> </li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="global-module-page-wrapper global-module">

					<div
						class="contact-module js-contact-module contact-module-default-bg contact-module-center global-module">
						<div class="global-module-wrapper">
							<div class="section-header-wrapper">
								<h2 class="section-header">Key Contacts</h2>
							</div>
							<ul class="main-contacts secondary-main-contacts">
								<li class="contact-information" v-for="(item,index) in LeaderList">
									<a class="professional-tile">
										<div class="content">
											<figure class="profile-image">
												<img :src="item.img">
											</figure>
											<div class="profile">
												<h3 class="name">{{item.name}}</h3>

												<div class="title">{{item.title}}</div>

												<ul class="locations">
													<li class="location">
														{{item.location}}
													</li>
												</ul>

												<div class="bottom">
													<div class="contact">
														<span class="phone">{{item.phone}}</span>
														<span class="contact-link-url email"><span class="iconfont icon-email"></span>Email</span>
													</div>

												</div>
											</div>
										</div>
									</a>
								</li>
							</ul>


							<button id="view-more" class="button-red contact-module-basic-button" @click="toPage('/people')">View
								All Related Professionals</button>
						</div>

					</div>

				</div>
			</div>
		</div>
		<footer class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="bm bm-linkedin" aria-label="Baker McKenzie LinkedIn "></a></li>
					<li class="social-link"><a class="bm bm-twitter" aria-label="Baker McKenzie Twitter"></a></li>
					<li class="social-link"><a class="bm bm-facebook" aria-label="Baker McKenzie Facebook "></a></li>
					<li class="social-link"><a class="bm bm-youtube" aria-label="Baker McKenzie YouTube"></a></li>
					<li class="social-link"><a class="bm bm-we-chat" aria-label="Baker McKenzie WeChat"></a></li>
					<li class="social-link"><a class="bm bm-rss" aria-label="Baker McKenzie RSS"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a>Disclaimers</a></li>
					<li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a title="Manage Choices">Cookie Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>
		
			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</footer>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				aboutSeeMore: 'none',
				tabIndex:1,
				topicBgList:[
					require('../../assets/test/02.jpeg'),
					require('../../assets/test/65.webp'),
					require('../../assets/test/55.webp'),
				],
				moreInsight:false,
				moreNews:false,
				LeaderList:[
					{
						name:'Richard G. Blunt',
						img:require('../../assets/test/04.webp'),
						title:'Partner',
						location:'London',
						phone:'+ 44 20 7919 1842',
						email:'w.com'
					},
					{
						name:'José Antonio Morán',
						img:require('../../assets/test/05.webp'),
						title:'Partner',
						location:'Chicago',
						phone:'+ 1 312 861 2829',
						email:'w.com'
					},
					{
						name:'Benjamín Torres-Barrón',
						img:require('../../assets/test/06.webp'),
						title:'Partner',
						location:'Mexico City',
						phone:'+ 52 55 5279 2979',
						email:'w.com'
					},
					{
						name:'Philip Thomson',
						img:require('../../assets/test/07.webp'),
						title:'Partner',
						location:'London',
						phone:'+ 44 20 7919 1518',
						email:'w.com'
					},
					{
						name:'Jon R. Ornolfsson',
						img:require('../../assets/test/08.webp'),
						title:'Partner',
						location:'Tokyo',
						phone:'+ 81 3 6271 9900',
						email:'w.com'
					},
					{
						name:'Sean Duffy',
						img:require('../../assets/test/09.jpeg'),
						title:'Partner',
						location:'Sydney',
						phone:'+ 61 2 8922 5270',
						email:'w.com'
					}
				],
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
			openAboutMore() {
				if (this.aboutSeeMore == 'none') {
					this.aboutSeeMore = 'block'
				} else {
					this.aboutSeeMore = 'none'
				}
			},
			selectTab(e){
				this.tabIndex = e
			},
			showMoreInsight(){
				this.moreInsight = !this.moreInsight
			},
			showMoreNews(){
				this.moreNews = !this.moreNews
			},
			toPage(path){
				this.$router.replace(path); 
			},
		}
	}
</script>

<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main {
		padding-top: 82px;
	}

	.embed-card__embed-bg {
		background-image: url('../../assets/test/01.jpeg');
	}
	.pcm-standard-background-image2 {
		background: url('../../assets/test/01.jpeg') no-repeat;
		background-size: cover;
	}
	.tabs-module .promo-content-tile .container-row{
	    height: auto;
	}
	.articles-related-module.featured-insights .featured-insights__collection[data-child-selector="4"] .featured-insights__tile[data-v-1ac23f08]:nth-of-type(n+4) {
	    display: block;
	}
	.icon-email {
		margin-right: 5px;
	}
	@media screen and (max-width: 47.9375em){
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main {
			padding-top: 63px;
		}
		.embed-card .embed-card__content{
		    max-width: 88%;
		}
		.global-module.global-module-page-wrapper .global-module-wrapper{
		    width: 88%;
		}
		.tabs-panel-nav-toggle {
			width: 86%;
		}
	}
</style>
